import { call, put, takeLatest } from "redux-saga/effects";
import { processErrors } from "../../../util/helpers";
import { fetchApplications as fetchApplicationsApi } from "./api";
import {
    fetchApplications,
    fetchApplicationsSuccess,
    fetchApplicationsFailed,
} from "./slice";

export function* getApplications(actions) {
    try {
        const { id } = actions.payload;
        const response = yield call(fetchApplicationsApi, id);
        const resp = response && response.data;
        yield put(fetchApplicationsSuccess(resp));
    } catch (error) {
        const message =
            processErrors(error?.response?.data) ||
            "Failed to fetch workspace applications";
        yield put(fetchApplicationsFailed(message));
    }
}

export function* watchFetchApplications() {
    yield takeLatest(fetchApplications.type, getApplications);
}
